var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{attrs:{"medium":"","color":"white"}},[_vm._v(" "+_vm._s(_vm.jobIcon())+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }